import { useContext } from 'react';
import { StateContext } from '../contexts/state-context';
import { AppContext} from '../models/common';

export const useAppContext = () : AppContext => {
  const { state } = useContext(StateContext);
  return {
    id: state?.context?.id || '',
    type: state?.context?.type ? `${state.context.type}` : 'merchant',
    name: state?.context?.name || '',
    email: state?.context?.owner.email || '',
    owner: state?.context?.owner.name || '',
    merchantSupportPhone: state?.context?.properties.supportPhone || '',
    merchantSupportEmail: state?.context?.properties.supportEmail || ''
  }
};
